import * as is from 'is';

/**
 * Compares values within 2 objects and updates the value if the newData value is different
 * than the originalData value
 * @param {*} originalData - the original object values
 * @param {*} newData - the updated object values
 * @returns
 */
export const compareData = (originalData, newData) => {
  const updatedData = {};
  if (!is.object(originalData) || !is.object(newData)) {
    throw new TypeError('compareData must be used on two objects');
  }

  for (const [key, value] of Object.entries(newData)) {
    if (is.object(value)) { // don't evaluate recursively.
      continue;
    }
    if (Object.prototype.hasOwnProperty.call(newData, key)
      && originalData[key] !== value) {
      updatedData[key] = value;
    }
  }
  return updatedData;
};
